export default {
	fetchMarketsPricesList ()
	{
		try{
			return this.$API.post('/market/symbol-thumb-trend').then((response) => response.data);
		}catch(error){
			console.log(error);
		}
	},
	fetchAllDynamicBaseCoin ()
	{
		try{
			return this.$API.get('/market/base-symbols').then((response) => response.data);
		}catch(error){
			console.log(error);
		}
	},
	fetchAllBaseCoin ()
	{
		try{
			return this.$API.get('/exchange/exchange-coin/base-symbol').then((response) => response.data);
		}catch(error){
			console.log(error);
		}
	},
	fetchFavoredMarkets ()
	{
		try{
			return this.$API.post('/exchange/favor/find');
		}catch(error){
			console.log(error);
		}
	},
	addToFavorites (store, payload)
	{
		try{
			return this.$API.post('/exchange/favor/add', payload);
		}catch(error){
			console.log(error);
		}
	},
	deleteFromFavorites (store, payload)
	{
		try{
			return this.$API.post('exchange/favor/delete', payload);
		}catch(error){
			console.log(error);
		}
	},
	fetchApplicationUrl ()
	{
		try{
			return this.$API.get('/market/application-download-links').then((response) => response);
		}catch(error){
			console.log(error);
		}
	},
	fetchStakingPlans ()
	{
		try{
			if(typeof FormData != 'undefined'){
				const data = new FormData();
				data.append('pageNo', 1);
				data.append('pageSize', 4);
				data.append('isVIP', 'IS_TRUE');
				return this.$API.post('/staking-api/public/staking-plans/web/all-full-info', data).then((response) => response.data);
			}
		}catch(error){
			console.log(error);
		}
	},
	fetchSupportedSourceCoins ()
	{
		try{
			return this.$API.get('/market/convert/support-coins').then((response) => response.data);
		}catch(error){
			console.log(error);
		}
	},
	fetchSupportedTargetCoins (store, payload)
	{
		try{
			return this.$API.get('/market/convert/support-coins/' + payload).then((response) => response.data);
		}catch(error){
			console.log(error);
		}
	},
	fetchConvertConfig (store, payload)
	{
		try{
			return this.$API.get('/market/convert/coin-config', { params: { fromCoin: payload.source, toCoin: payload.target } }).then((response) => response.data);
		}catch(error){
			console.log(error);
		}
	},
};
